import { Banknote, HandCoins, Receipt, Repeat, ShoppingCart, Users } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useIsOwner } from '@/auth/useSession';
import { Card, PageHeader } from '@/components/ui';
import { useFormat } from '@/lib/format';
import { useBuyerLedgers } from './useMoney';

/** Money hub (bottom bar "Money", S4). */
export function MoneyPage() {
  const { t } = useTranslation();
  const f = useFormat();
  const isOwner = useIsOwner();
  const ledgers = useBuyerLedgers() ?? [];
  const total = ledgers.reduce((a, l) => a + Math.max(0, l.ledger.balanceSantim), 0);
  const credit = ledgers.reduce((a, l) => a + Math.max(0, -l.ledger.balanceSantim), 0);
  const overdue = ledgers.reduce((a, l) => a + l.ledger.overdueSantim, 0);
  const links = [
    { to: '/sales/new', label: t('money.recordSale'), icon: ShoppingCart },
    { to: '/payments/new', label: t('money.recordPayment'), icon: HandCoins },
    { to: '/buyers', label: t('money.buyers'), icon: Users },
    { to: '/expenses/new', label: t('expenses.add'), icon: Receipt },
    { to: '/expenses', label: t('expenses.title'), icon: Banknote },
    ...(isOwner ? [{ to: '/expenses/recurring', label: t('recurring.title'), icon: Repeat }] : []),
  ];
  return (
    <div className="space-y-4">
      <PageHeader title={t('money.title')} />
      <Card className="grid grid-cols-2 gap-3">
        <div>
          <div className="text-sm text-stone-600">{t('money.receivables')}</div>
          <div className="text-2xl font-bold tabular-nums">{f.birr(total)}</div>
        </div>
        <div>
          <div className="text-sm text-stone-600">{t('money.overdue')}</div>
          <div className={`text-2xl font-bold tabular-nums ${overdue > 0 ? 'text-red-700' : ''}`}>{f.birr(overdue)}</div>
        </div>
        <div>
          <div className="text-sm text-stone-600">{t('money.buyersCredit')}</div>
          <div className={`text-2xl font-bold tabular-nums ${credit > 0 ? 'text-green-800' : ''}`}>{f.birr(credit)}</div>
        </div>
      </Card>
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
        {links.map(({ to, label, icon: Icon }) => (
          <Link key={to} to={to} className="flex min-h-24 flex-col items-center justify-center gap-2 rounded-2xl border border-stone-200 bg-white p-3 text-center font-medium">
            <Icon className="h-7 w-7 text-brand-800" />
            {label}
          </Link>
        ))}
      </div>
    </div>
  );
}
